"use client";
import { jsx as a, jsxs as r } from "react/jsx-runtime";
import * as o from "@radix-ui/react-dialog";
import f, { isValidElement as c } from "react";
import { Close as p } from "@videoblocks/react-icons";
import { cn as i } from "../../../utils/utils.mjs";
import { Text as g } from "../Text/Text.mjs";
const N = ({ ...t }) => /* @__PURE__ */ a(o.Root, { "data-slot": "dialog", ...t }), C = ({ ...t }) => /* @__PURE__ */ a(o.Trigger, { "data-slot": "dialog-trigger", ...t }), u = ({ ...t }) => /* @__PURE__ */ a(o.Portal, { "data-slot": "dialog-portal", ...t }), x = ({ ...t }) => /* @__PURE__ */ a(o.Close, { "data-slot": "dialog-close", ...t }), m = f.forwardRef(({ className: t, ...e }, s) => /* @__PURE__ */ a(
  o.Overlay,
  {
    "data-slot": "dialog-overlay",
    className: i(
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/60",
      t
    ),
    ...e,
    ref: s
  }
));
m.displayName = "DialogOverlay";
const w = ({ className: t, children: e, showCloseButton: s = !0, ...l }) => /* @__PURE__ */ r(u, { "data-slot": "dialog-portal", children: [
  /* @__PURE__ */ a(m, {}),
  /* @__PURE__ */ r(
    o.Content,
    {
      "data-slot": "dialog-content",
      className: i(
        "bg-background",
        "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
        "fixed top-[50%] left-[50%] z-50",
        "grid w-full max-w-[calc(100%-2rem)]",
        "translate-x-[-50%] translate-y-[-50%] gap-4",
        "rounded-sm border p-6 shadow-lg",
        "duration-200 md:max-w-lg",
        t
      ),
      ...l,
      children: [
        e,
        s && /* @__PURE__ */ r(
          x,
          {
            "data-slot": "dialog-close",
            className: `ring-offset-background focus:ring-ring
                    data-[state=open]:bg-accent data-[state=open]:text-muted-foreground
                    absolute top-8 right-4 rounded-xs
                    opacity-70 transition-opacity hover:opacity-100
                    focus:ring-2 focus:ring-offset-2 focus:outline-hidden
                    disabled:pointer-events-none [&_svg]:pointer-events-none
                    [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4`,
            children: [
              /* @__PURE__ */ a(p, { className: "w-4 h-4 fill-current" }),
              /* @__PURE__ */ a("span", { className: "sr-only", children: "Close" })
            ]
          }
        )
      ]
    }
  )
] }), z = ({ className: t, ...e }) => /* @__PURE__ */ a(
  "div",
  {
    "data-slot": "dialog-header",
    className: i("flex flex-col gap-0.5 text-center sm:text-left", t),
    ...e
  }
), T = ({ className: t, ...e }) => /* @__PURE__ */ a(
  "div",
  {
    "data-slot": "dialog-footer",
    className: i("flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", t),
    ...e
  }
), _ = ({
  className: t,
  children: e,
  fontSize: s = "lg",
  fontWeight: l = "semibold",
  fontFamily: n = "inter",
  ...d
}) => /* @__PURE__ */ a(o.Title, { "data-slot": "dialog-title", className: t, ...d, children: /* @__PURE__ */ a(g, { asChild: !0, fontSize: s, fontWeight: l, fontFamily: n, children: c(e) ? e : /* @__PURE__ */ a("span", { children: e }) }) }), k = ({
  className: t,
  children: e,
  fontSize: s = "sm",
  fontWeight: l = "regular",
  fontFamily: n = "inter",
  ...d
}) => /* @__PURE__ */ a(
  o.Description,
  {
    "data-slot": "dialog-description",
    className: i("text-muted-foreground", t),
    ...d,
    children: /* @__PURE__ */ a(g, { asChild: !0, fontSize: s, fontWeight: l, fontFamily: n, children: c(e) ? e : /* @__PURE__ */ a("span", { children: e }) })
  }
);
export {
  N as Dialog,
  x as DialogClose,
  w as DialogContent,
  k as DialogDescription,
  T as DialogFooter,
  z as DialogHeader,
  m as DialogOverlay,
  u as DialogPortal,
  _ as DialogTitle,
  C as DialogTrigger
};
